import React from 'react'
import styles from './DialogButton.scss'
import {Button} from 'common/Button'
import {ActionLink} from 'common/ActionLink'
import {Icon} from 'common/Icon'
import cx from 'classnames'

// todo switch to a focus-based method for tracking active state, so that
// we don't eat clicks
export class DialogButton extends React.Component {
  static defaultProps = {
    type: 'button'
  }

  constructor (props) {
    super(props)
    this.state = {showDialog: !!props.defaultShowDialog}
  }

  toggleDialog = () => {
    const {showDialog} = this.state
    this.setState({showDialog: !showDialog})
  }

  hideDialog = (e) => {
    this.setState({showDialog: false})
  }

  render () {
    const {children, label, type, className} = this.props
    const {showDialog} = this.state
    const Container = type === 'button' ? Button : ActionLink

    return (
      <Container className={cx(styles.DialogButton, className)}
        active={showDialog}
        onClick={this.toggleDialog}>
        {label} <Icon i='ios-arrow-down' />
        {showDialog && <Overlay onClick={this.hideDialog} />}
        {showDialog && <Dialog><div className={styles.dialogContent}>{children}</div></Dialog>}
      </Container>
    )
  }
}

export const Dialog = ({className, ...props}) => (
  <div className={cx(styles.dialog, className)} {...props} />
)

const Overlay = ({onClick}) => (
  <div className={styles.Overlay} />
)
